<template>
  <section class="seltos-keji-page">
    <BasicVideoPicsTextSwiper :title="title" :subtitle="subtitle" :imgs="imgs" id="10"></BasicVideoPicsTextSwiper>
  </section>
</template>
<script>
import BasicVideoPicsTextSwiper from '@/components/basic-videopicstext-swiper-new-keji.vue'
export default {
  data() {
    return {
      title: '智趣座舱新体验',
      subtitle:'懂车懂路更懂你',
      imgs: [

        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/tech/pc/keji3.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/tech/mob/keji3.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '车载游戏中心内置12款小游戏<br/>支持触控屏操控、蓝牙手柄连接车辆硬件<br/>3种操作方式',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/tech/pc/keji2.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/tech/mob/keji2.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '车载K歌房<br/>支持无麦K歌、无线双麦克风、<br/>前后排同步欢唱',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/tech/pc/dbqjs.jpg',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/newseltos/tech/mob/dbqjs.jpg',
          videoPc: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          videoMob: 'https://img.kia.cn/content/videos/20230821/ev5_clear.mp4',
          posterPc: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          posterMob: 'https://uat.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/experience/img1.png',
          title: '杜比全景声<br/>' + '声音环绕如临现场',
          // text: '（含前排中置安全气囊）',
          type: 'img'
        }
      ],
    }
  },
  components: {
    BasicVideoPicsTextSwiper
  },
  mounted() {
  }
}
</script>
<style>
.seltos-keji-page {
  background: #000000;
  color: #FFFFFF;
}
.seltos-keji-page .title-outer .main-title,
.seltos-keji-page .title-outer .sub-title {
  color: #FFFFFF !important;
  /* font-size: 2.083333vw !important;
  font-weight: 600;
  line-height: 2.1875vw; */
  font-size: calc(42 / 1920 * 100vw) !important;
  line-height: calc(61 / 1920 * 100vw) !important;
  font-family: zhonghei;
}
.seltos-keji-page .title-outer .main-title-mob,
.seltos-keji-page .title-outer .sub-title-mob {
  color: #FFFFFF !important;
  /* font-size: calc(22/375*100vw) !important;
  font-weight: 600;
  line-height: 2.1875vw; */
  font-size: calc(38 / 750 * 100vw) !important;
  line-height: calc(60 / 750 * 100vw) !important;
  font-family: zhonghei;
}
/* swiper content text white */
.seltos-keji-page .title,
.seltos-keji-page .text,
.seltos-keji-page .title-mob {
  color: #FFFFFF !important;
}
/* swiper pagination white */
.seltos-keji-page .swiper-pagination-bullet {
  background-color: #FFFFFF !important;
  opacity: 0.3 !important;
}
.seltos-keji-page .swiper-pagination-bullet-active {
  background-color: #FFFFFF !important;
  opacity: 1 !important;
}
/* swiper slide mob background black */
.seltos-keji-page .swiper-slide-mob {
  background-color: rgba(32, 32, 32, 1) !important;
}
</style>
